export default {

  // Change the polling interval when the current environment is the development environment(yarn start)
  POLLING_INTERVAL: process.env.NODE_ENV === "development" ? 15000 : 5000,

  // Change the update file max size when the current environment is the development environment(yarn start)
  LARGEST_FILE: process.env.NODE_ENV === "development" ? 1024 * 1024 : 4 * 1024
      * 1024
}